import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="public-nav px-6 py-4 flex justify-between items-center border-b border-slate-800">
      <div className="flex items-center space-x-2">
        <img
          src="/imgs/logo.png"
          alt="Tabletop Recorder Logo"
          className="h-16"
        />
      </div>
      <div className="flex items-center space-x-4">
        <Link to="/login" className="text-primary hover:text-primary-light">
          Log In
        </Link>
        <Link
          to="/register"
          className="bg-primary hover:bg-primary-light px-4 py-2 rounded-lg">
          Sign Up
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
